import React, { useEffect, useState } from "react";
import "./Footer.css";
import logo from "../Navbar/a1.png"; // replace with your logo path
import { FaFacebookF, FaLinkedinIn, FaTwitter } from "react-icons/fa";
import axios from "axios";
import { Link } from "react-router-dom";
import { BsTwitterX } from "react-icons/bs";


const Footer = () => {


  const [serviceMenus, setServiceMenus] = useState([]);

  useEffect(() => {
    const fetchServiceMenus = async () => {
      try {
        const response = await axios.get("https://infosightapi.emedha.in/api/services-menus");
        setServiceMenus(response.data);
      }
      catch (error) {
        console.error("Error fetching service menus:", error);

      }

    }; fetchServiceMenus();
  }, []);


  return (
    <footer className="footer">
      <div className="footer-container">

        {/* About Section */}
        <div className="footer-col about">
          <img src={logo} alt="Company Logo" className="footer-logo" />
          {/* <p>
            Our team of consultants and design engineers specialize in IBMS,
            AV, ELV, SECURITY, and ACOUSTICS, with years of hands-on experience
            delivering high-quality solutions.
          </p> */}
          <p>
          
             {/* integrated ELV s ystems, including IBMS, Security, AV, and IT/ICT,
            with extensive hands-on experience delivering reliable, high-quality solutions, alongside dedicated expertise in Sustainability and Acoustics. */}
          We specialize in ACOUSTICS,
SECURITY,
SRA,
IT/ICT,
IBMS,
AV,
SUSTAINABILITY & GREEN BUILDING and 
PROJECT MANAGEMENT
         
          </p>
        </div>

        {/* Useful Links */}
        <div className="footer-col">
          <h2>Useful Links</h2>
          <ul>
            <li><a href="/">Home</a></li>
            <li><a href="/about">About us</a></li>
            <li><a href="/project">Our Projects</a></li>
            <li><a href="/quality-policy">Quality Policy</a></li>
            <li><a href="/contact">Contact Us</a></li>
            <li><a href="#">Company Profile</a></li>
          </ul>
        </div>

        {/* Services */}
        {/* Services */}
        <div className="footer-col">
          <h2>Our Services</h2>
          <ul>
            {serviceMenus.map((menu) => {
              const cleanSlug = (menu.heading || menu.menu_name)
                ?.toLowerCase()
                .replace(/\s+/g, '-')
                .replace(/\//g, '/');

              return (
                <li key={menu.id}>
                  <Link to={`/service/${cleanSlug}`} style={{ fontSize: '14px' }}>
                    {menu.menu_name}
                  </Link>
                </li>
              );
            })}
          </ul>
        </div>

        {/* Social / Contact */}
        <div className="footer-col">
          <h2>Stay Connected</h2>
          <p>Reach out to us for tailored consulting services.</p>
          <div className="social-icons">
           <a href="#" target="_blank" rel="noreferrer">
    <FaFacebookF />
  </a>
  <a href="#" target="_blank" rel="noreferrer">
    <BsTwitterX />
  </a>
  <a href="https://www.linkedin.com/company/infosight-infrastructure-consultants-llp/" target="_blank" rel="noreferrer">
    <FaLinkedinIn />
  </a>
          </div>
        </div>
      </div>

      {/* Bottom Section */}
      <div className="footer-bottom">
        <p>Copyright © 2025 Infosight. All Rights Reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
